import type { Expense as GQLItem, VariableExpenseEnum } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type Expense = {
  id: number;
  name: string;
  editable: boolean;
  amount?: number;
  calculationType?: VariableExpenseEnum;
  calculationValue?: number;
};

export const fromGql = (item: GQLItem): Expense =>
  take<Expense, GQLItem>(item, 'id', 'name', 'amount', 'calculationType', 'calculationValue', 'editable');
